import { EL_TG_LINK_BASE } from '@/core/config/externalLinks'

export const externalLinks = {
  telegram: (address: string) => {
    return `${EL_TG_LINK_BASE}/${address}`
  },
}
